import { ROLES } from 'constants/index';
import { UserRoles } from 'enums';
import { iUserState } from 'types';
import { COMMON, USER } from '../constants/index';
import { initialState } from '../initialState/initialState';

export const userReducer = (
  state: iUserState = initialState.user,
  action
): iUserState => {
  switch (action.type) {
    case USER.setLoginData: {
      const { roleId } = action.payload.data;

      return {
        ...state,
        loggedInData: action.payload.data,
        allRoles: action.payload.roles,
        isLoggedIn: true,
        role:
          (roleId === ROLES.super_admin && UserRoles.SuperAdmin) ||
          (roleId === ROLES.owner && UserRoles.Owner) ||
          (roleId === ROLES.admin && UserRoles.Admin) ||
          UserRoles.Client,
      };
    }
    case USER.changeView: {
      const userSettings = { ...state.userSettings };
      userSettings.activeView = action.payload;
      return { ...state, userSettings };
    }
    case USER.setClientChoosed: {
      return { ...state, clientChoosed: action.payload };
    }
    case USER.setUserPermissions: {
      return {
        ...state,
        userPermissions: action.payload,
      };
    }
    case USER.changeUserRole: {
      const roleId = action.payload;
      const loginData = state.loggedInData;
      if (roleId && loginData) loginData.roleId = roleId || '';
      //  console.log('roleId_______', roleId);

      let role = UserRoles.Client;
      if (Number(roleId) === ROLES.super_admin) role = UserRoles.SuperAdmin;
      if (Number(roleId) === ROLES.owner) role = UserRoles.Owner;
      if (Number(roleId) === ROLES.admin) role = UserRoles.Admin;
      return {
        ...state,
        loggedInData: loginData,
        role,
      };
    }
    case USER.set2FAData: {
      return { ...state, twoFAVerificationData: action.payload };
    }
    case USER.setResetPasswordData: {
      return { ...state, resetPasswordData: action.payload };
    }
    case USER.setRemoveTeammate: {
      return { ...state, removeTeammateData: action.payload };
    }
    case USER.updateLoggedInUserData: {
      return { ...state, loggedInData: action.payload };
    }
    case USER.setCanFetchRoles: {
      return { ...state, canFetchRoles: action.payload };
    }
    case USER.setUserCompanyId: {
      return { ...state, userCompanyId: action.payload };
    }
    case USER.setUserId: {
      return { ...state, userId: action.payload };
    }
    case COMMON.reset: {
      return initialState.user;
    }
    default:
      return state;
  }
};
